import React, { useState } from 'react';
import './signup.css'
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';

const Signup = () => {

    const navigate = useNavigate();

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const handleSignup = async () => {
      const { error } = await supabase.auth.signUp({
            email,
            password,
            options: {
                data: {
                    full_name: name
                }
            }
        });

        if (error) {
            alert(error.message);
        } else {
            alert("Account created successfully!");
            navigate('/home');
        }
    };

    return (
    <>
    <section>
        <div className="containerr">

            <div className="signup">

                <div className='logoo'></div>
                <div className='overlay'></div>

                <div className='signupdiv'>

                    <div className='welcome'>
                        <h1 className='welcometxt'>Create Account</h1>
                        <p className='loginp'>Join us and start your journey</p>
                    </div>

                    <div className='inputsdiv'>

                        <div className='inputbox'>
                            <label>Full Name</label>
                            <input
                                type="text"
                                placeholder='Enter your name'
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </div>

                        <div className='inputbox'>
                            <label>Email</label>
                            <input
                                type="email"
                                placeholder='Enter your email'
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>

                        <div className='inputbox'>
                            <label>Password</label>
                            <input
                                type="password"
                                placeholder='Create password'
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </div>

                    </div>

                    <button
                        className='signupbt'
                        onClick={handleSignup}
                    >
                        SIGN UP
                    </button>

                    <p className='bottomtxt'>
                        Already have an account?
                        <span onClick={() => navigate('/login')}>
                            Login
                        </span>
                    </p>

                </div>

            </div>

        </div>
    </section>
    </>
    );
}

export default Signup;